module.exports = __webpack_public_path__ + "static/media/logoTransperent.21402004.png";